export default __webpack_public_path__ + "static/qlab-1-icon-0962b5763fffdc2b3def6e34595b4a9c.png";